export default __webpack_public_path__ + "static/assets/efd7de8f57f6d47445c1b9d3033d08ed.gif";